// extracted by mini-css-extract-plugin
export default {"searchAndSort":"XFwZ5rnNzr"};